import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';

const Datas = [
    {
        id: 1,
        title: "Innovation",
        para: "Trying new ideas and approaches to solve problems effectively, delivering creative and smart solutions."
    },
    {
        id: 2,
        title: "Timely Delivery",
        para: "Ensuring accuracy, quality, and reliability with every project delivered within the promised timeline."
    },
    {
        id: 3,
        title: "Quality Products",
        para: "Providing secure and reliable products with assured quality for the growth and success of every business."
    },
    {
        id: 4,
        title: "Customer Friendly",
        para: "Helping customers by understanding their needs and ideas, offering solutions that truly meet their expectations."
    },
    {
        id: 5,
        title: "Our History",
        para: "To be client-centric, technology-driven, adaptive, and creative in our approach for excellence and successful implementation."
    },

    {
        id: 6,
        title: "Our Mission & Vision",
        para: "To be admired with integrity, professionalism, and dedication, while being client-centric, innovative, and delivering the best IT solutions."
    }
]




const AboutThree = () => {
    return (
        <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20">
            <div className="container">
                <SectionTitle 
                    subtitle="Our Values"
                    title="Why Choose Us?"
                    description="We focus on delivering quality products, building customer-friendly solutions, ensuring timely delivery, and driving innovation. With a strong history, mission, and vision, we are committed to creating lasting value for your business."
                    textAlignment="heading-left heading-light-left mb--100"
                    textColor=""
                />

                <div className="row">
                    {Datas.map((data) => (
                        <div className="col-lg-4" key={data.id}>
                            <div className="about-quality">
                                <h3 className="sl-number">{data.id}</h3>
                                <h5 className="title">{data.title}</h5>
                                <p>{data.para}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1"><img src={"/images/others/circle-1.png"} alt="Circle" /></li>
                <li className="shape shape-2"><img src={"/images/others/line-3.png"} alt="Circle" /></li>
                <li className="shape shape-3"><img src={"/images/others/bubble-5.png"} alt="Circle" /></li>
            </ul>
        </div>
    )
}

export default AboutThree;